// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"20905": "fcbd8827","3042": "d610d5b4","39704": "bab1ab91","60238": "bab1ab91","70561": "106ac653","8150": "3f898976",}[chunkId] + ".css"
}